module.exports = __webpack_public_path__ + "static/media/ear-pain-copy.9100fed2.svg";